var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M3.172 4l-.708.707L6 8.243l3.536-3.536L8.828 4 6 6.828 3.172 4z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }